import { createMovieClip } from "../../../../common/functions/Functions_General";
import { GameData } from "../../gamestate/gameData";

export class sergioWild {
    private parent: PIXI.Container;
    private animationContainer: PIXI.Container;
    private ani_jumpHeight1: PIXI.extras.AnimatedSprite;
    private ani_jumpHeight2: PIXI.extras.AnimatedSprite;
    private ani_jumpHeight3: PIXI.extras.AnimatedSprite;
    private ani_jumpLeft: PIXI.extras.AnimatedSprite;
    private currentColumn: number;
    private fadeOutTween: PIXI.tween.Tween;
    private ani_idle: PIXI.extras.AnimatedSprite;
    // private enableIdleAnimation: boolean;
    // private isClearing:boolean;
    private indexN:number;
    private activeGameData:GameData;
    private animationActive:boolean
    constructor(parent: PIXI.Container,activeGameData:GameData,index:number) {

      this.indexN=index;
      this.setSergioInAnimationActive(false);
      this.activeGameData=activeGameData;
      this.parent = new PIXI.Container();
      this.parent.alpha = 1;
      this.parent.y = -444 + 840 - 83;
      this.parent.x = 425 + 269;
      parent.addChild(this.parent);
  
      let normalizeX = -266 * 3;
      this.animationContainer = new PIXI.Container();
      this.parent.addChild(this.animationContainer);
      this.animationContainer.x = normalizeX;
  
      this.ani_jumpHeight1 = createMovieClip("SergioIn", 0, 51);
      this.ani_jumpHeight1.anchor.set(0.5);
      this.ani_jumpHeight1.scale.set(0.9);
      this.ani_jumpHeight1.animationSpeed = .5;
      this.animationContainer.addChild(this.ani_jumpHeight1);
      this.ani_jumpHeight1.x = -266 * 2;
  
      this.ani_jumpHeight2 = createMovieClip("SergioIn", 0, 50);
      this.ani_jumpHeight2.anchor.set(0.5);
      this.ani_jumpHeight2.scale.set(0.9);
      this.ani_jumpHeight2.animationSpeed = 1;
      this.ani_jumpHeight2.x = -266 * 2;
      this.animationContainer.addChild(this.ani_jumpHeight2);
  
      this.ani_jumpHeight3 = createMovieClip("SergioIn", 0, 50);
      this.ani_jumpHeight3.anchor.set(0.5);
      this.ani_jumpHeight3.scale.set(0.9);
      this.ani_jumpHeight3.animationSpeed = 1;
      this.ani_jumpHeight3.x = -266 * 2;
      this.animationContainer.addChild(this.ani_jumpHeight3);
  
      this.ani_jumpLeft = createMovieClip("SergioNewReel", 0, 23);
      this.ani_jumpLeft.anchor.set(0.5);
      this.ani_jumpLeft.scale.set(0.9);
      this.ani_jumpLeft.animationSpeed = .7;
      this.ani_jumpLeft.x = -266 * 2;
      this.animationContainer.addChild(this.ani_jumpLeft);
  
    //   this.enableIdleAnimation = false;
      this.ani_idle = createMovieClip("SergioIdle", 0, 23);
      this.ani_idle.anchor.set(0.5);
      this.ani_idle.scale.set(0.9);
      this.ani_idle.animationSpeed =.4;
      this.ani_idle.x = -266 * 2;
      // this.ani_idle.y = 300;
      this.animationContainer.addChild(this.ani_idle);
      this.ani_idle.loop = true;
      this.ani_idle.play();
      this.ani_jumpLeft.onComplete = this.onJumpEnd;
      this.ani_jumpHeight1.onComplete = this.playSantaIdle;
      this.ani_jumpHeight2.onComplete = this.playSantaIdle;
      this.ani_jumpHeight3.onComplete = this.playSantaIdle;
  



      this.ani_jumpHeight1.onFrameChange = function (wildObj:sergioWild) {
				// console.log(this.currentFrame,startFrame,endFrame)

        let percentagecompleteBeforeAllowPlay=.25;

				if (this.currentFrame >= this.totalFrames*percentagecompleteBeforeAllowPlay) {				
          if(wildObj.getIsAnimationActive()==true)
          {
            wildObj.setSergioInAnimationActive(false);
          }
				}
			}.bind(this.ani_jumpHeight1,this);

      //-define when to end the sergio wait animation

      // this.ani_jumpLeft.onFrameChange = function(
      //   endFrame: number,
      //   santaObj: santaWild
      // ) {
      //   if (this.currentFrame >= endFrame) {
      //     // santaObj.setUpplaySantaIdle(true);
      //     // console.log(santaObj)
      //     santaObj.ani_idle.alpha=0;
      //     santaObj.ani_idle.gotoAndPlay(0)
      //   }
      // }.bind(this.ani_jumpLeft, 44, this);
  
     this.ani_idle.onFrameChange = function(
        santaObj: sergioWild
      ) {
  
        let a=santaObj.ani_jumpHeight1.playing;
        let b=santaObj.ani_jumpHeight1.playing;
        let c=santaObj.ani_jumpHeight1.playing;
  
         if(a||b||c)
         {
          // console.log(a,b,c);
          // console.log("----------",santaObj.currentColumn)
            santaObj.ani_idle.alpha=0;
  
         }
          
        
      }.bind(this.ani_jumpLeft, this);
  
  
      this.ani_jumpHeight3.loop = false;
      this.ani_jumpHeight2.loop = false;
      this.ani_jumpHeight1.loop = false;
      this.ani_jumpLeft.loop = false;
  
      this.fadeOutTween = PIXI.tweenManager.createTween(this.animationContainer);
      this.fadeOutTween.to({ alpha: 0 });
      this.fadeOutTween.time = 500 / 0.75; //default 350
      // this.ani_jumpLeftTween.pingPong=true;
      this.fadeOutTween.easing = PIXI.tween.Easing.linear();
      this.fadeOutTween.loop = false;
      this.fadeOutTween.on("end", this.clear);
  
      this.currentColumn = 0;

  
  
      this.clear();

    }
    public getIsAnimationActive=():boolean=>
    {

      
      return this.animationActive
    }

    private setSergioInAnimationActive=(bool:boolean):void=>
    {
      this.animationActive=bool;
    }
    private playSantaIdle=():void=>
    {
      this.setSergioInAnimationActive(false);
      this.ani_idle.alpha=1;
      this.ani_idle.gotoAndPlay(0);//--fix idle jump
    //   this.enableIdleAnimation = true;
      this.ani_jumpHeight1.alpha=0;
      this.ani_jumpHeight2.alpha=0;
      this.ani_jumpHeight3.alpha=0;
      this.ani_jumpLeft.alpha=0;
  
    }
  
    public addNewSantaAt=(column: number, row: number):void=> {
      this.ani_jumpLeft.alpha = 0;
      this.ani_idle.alpha = 0;
      this.currentColumn = column;
      //-allow to  put the santa to defined column and row 
      let animation = this.ani_jumpHeight1; //default;
      if (row == 2) {
        animation = this.ani_jumpHeight2;
      } else if (row == 3) {
        animation = this.ani_jumpHeight3;
      }
      animation.alpha = 1;
      animation.gotoAndPlay(0);
      if(this.activeGameData.replayMode==false)
      {
        this.setSergioInAnimationActive(true);
      }
      this.animationContainer.x = column * 266;
      if(column>0){ this.parent.alpha=1;}
      else{ this.parent.alpha=0;}
    }
    public reloadSantaAt=(column: number, row: number):void=> {
      this.ani_jumpLeft.alpha = 0;
      this.ani_idle.alpha = 0;
      this.currentColumn = column;
      //-allow to  put the santa to defined column and row 
      let animation = this.ani_jumpHeight1; //default;
      if (row == 2) {
        animation = this.ani_jumpHeight2;
      } else if (row == 3) {
        animation = this.ani_jumpHeight3;
      }
   
      this.setSergioInAnimationActive(true);
      animation=this.ani_idle
      animation.alpha = 1;
      animation.gotoAndPlay(0);
      this.animationContainer.x = column * 266;
      if(column>0){ this.parent.alpha=1;}
      else{ this.parent.alpha=0;}
      this.setSergioInAnimationActive(false);
    }

 
  
    private switchToJump = (): void => {
        //-make santa ready to jump anytime
      this.ani_jumpHeight1.alpha = 0;
      this.ani_jumpHeight2.alpha = 0;
      this.ani_jumpHeight3.alpha = 0;
      this.ani_idle.alpha = 0;
      this.ani_jumpLeft.alpha = 1;
    };
  
    public setSantaLocation = (index: number): void => {
        this.parent.alpha=1;

      this.ani_idle.alpha = 1;
      this.ani_jumpLeft.alpha = 0;
      this.switchToJump();
      this.currentColumn = index;
      this.animationContainer.x = index * 266;
    };
    public getCurrentColumn = (): number => {
      // console.log("Current Col",this.currentColumn)
      return this.currentColumn;
    };
    // private completePreviousJump = (): void => {
    //   // //allows to finish the previous animation before making new ones
    //   if (this.ani_jumpHeight1.playing) {
    //     this.ani_jumpHeight1.stop();
    //     this.switchToJump();
    //   }
    //   if (this.ani_jumpHeight2.playing) {
    //     this.ani_jumpHeight2.stop();
    //     this.switchToJump();
    //   }
    //   if (this.ani_jumpHeight3.playing) {
    //     this.ani_jumpHeight3.stop();
    //     this.switchToJump();
    //   }
    //   if (this.ani_jumpLeft.playing) {
    //     this.ani_jumpLeft.stop();
    //     this.onJumpEnd();
    //     console.log("stop");
    //   }
    // };
  
    public startJump = (): void => {
    //   this.completePreviousJump; //();
      if (this.currentColumn >= 0) {
        // console.log("JUMP STARTED", this.currentColumn);
        this.parent.alpha=1;
        this.switchToJump();
        this.ani_jumpLeft.gotoAndPlay(0);
        // if(this.activeGameData.skipAnimation)
        // {
        //   this.ani_jumpLeft.animationSpeed=5;
        // }
        // else
        // {
        //   this.ani_jumpLeft.animationSpeed=1.5;
        // }
        this.activeGameData;
      }
    };
    private onJumpEnd = (): void => {

        this.switchToJump();

          if (this.currentColumn == 0) 
        {
            this.animationContainer.x = -266;
                this.clear();
        }
        // this.playSantaIdle();
      if (this.currentColumn > 0) {
        this.animationContainer.x = (this.currentColumn) * 266;

      } else {
        this.animationContainer.x = -266;
        this.clear();
        // this.enableIdleAnimation=false
      }

      if(this.currentColumn>0)
      { 
        this.parent.alpha=1;
        let otherAnimationActive=false;
        if(this.ani_jumpHeight1.playing){otherAnimationActive=true};
        if(this.ani_jumpHeight2.playing){otherAnimationActive=true}
        if(this.ani_jumpHeight3.playing){otherAnimationActive=true}
        if(otherAnimationActive===false)
        {
        //   this.playSantaIdle();
        }
      
      }
      else
      {
                  // this.parent.alpha=1;
      }
      this.animationContainer.x = (this.currentColumn-1) * 266;//--move one case to left a
  
      this.ani_idle.alpha=1;
      this.ani_jumpLeft.alpha=0;
      this.ani_idle.gotoAndPlay(0);
   
      this.ani_jumpLeft.gotoAndStop(0);

      if(this.indexN===5)
      { 
        
        this.ani_idle.alpha=0;
      }
    };
  
    public setCurrentColumn = (num: number): void => {
      this.currentColumn = num;
      // console.log(num);
    };
  
    public hideSantaAndResetColumn = (): void => {
      this.animationContainer.x = 0;
      this.ani_jumpHeight1.alpha = 0;
      this.ani_jumpHeight2.alpha = 0;
      this.ani_jumpHeight3.alpha = 0;
      this.ani_jumpLeft.alpha = 0;
      this.ani_idle.alpha = 0;
      this.currentColumn = 0;
    };
    public clear = (): void => {
  
      this.ani_jumpHeight1.gotoAndStop(0);
      this.ani_jumpHeight2.gotoAndStop(0);
      this.ani_jumpHeight3.gotoAndStop(0);
      this.ani_jumpLeft.gotoAndStop(0);
      this.hideSantaAndResetColumn();
      this.animationContainer.x = 0;
      this.currentColumn = 0;
    //   this.enableIdleAnimation =false;
  
      this.parent.alpha=0;
      
  
    };
  }
  